import { render, staticRenderFns } from "./RepresentativeForm.vue?vue&type=template&id=2fdd2830&scoped=true"
import script from "./RepresentativeForm.vue?vue&type=script&lang=js"
export * from "./RepresentativeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdd2830",
  null
  
)

export default component.exports